import { Application } from "@hotwired/stimulus"
import Dropdown from 'stimulus-dropdown'
import ReadMore from 'stimulus-read-more'
import Reveal from 'stimulus-reveal-controller'


const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

application.register('dropdown', Dropdown)
application.register('read-more', ReadMore)
application.register('reveal', Reveal)

export { application }
